import { render, staticRenderFns } from "./GetReminderReportData.vue?vue&type=template&id=79a6ec08&scoped=true&"
import script from "./GetReminderReportData.vue?vue&type=script&lang=js&"
export * from "./GetReminderReportData.vue?vue&type=script&lang=js&"
import style0 from "./GetReminderReportData.vue?vue&type=style&index=0&id=79a6ec08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a6ec08",
  null
  
)

export default component.exports